import { addDays, endOfMonth, endOfYear, format, startOfDay, startOfMonth } from "date-fns";

export type DashboardListRangeKey = "8w" | "month" | "3m" | "year";

export const DASHBOARD_LIST_RANGE_OPTIONS: {
  key: DashboardListRangeKey;
  label: string;
  subtitle: string;
}[] = [
  { key: "8w", label: "8 weeks", subtitle: "next 8 weeks" },
  { key: "month", label: "This month", subtitle: "calendar month" },
  { key: "3m", label: "3 months", subtitle: "next 3 months" },
  { key: "year", label: "This year", subtitle: "rest of this year" },
];

export function dashboardListRangeBounds(
  key: DashboardListRangeKey,
  today: Date,
): { from: string; to: string; limit: number } {
  const start = startOfDay(today);
  const from = format(start, "yyyy-MM-dd");
  if (key === "8w") {
    return { from, to: format(addDays(start, 56), "yyyy-MM-dd"), limit: 25 };
  }
  if (key === "month") {
    const monthStart = startOfMonth(start);
    const monthEnd = endOfMonth(start);
    return {
      from: format(monthStart, "yyyy-MM-dd"),
      to: format(monthEnd, "yyyy-MM-dd"),
      limit: 30,
    };
  }
  if (key === "3m") {
    return { from, to: format(addDays(start, 90), "yyyy-MM-dd"), limit: 40 };
  }
  return {
    from,
    to: format(endOfYear(start), "yyyy-MM-dd"),
    limit: 60,
  };
}

export function normalizeDashboardListRange(raw: string): DashboardListRangeKey | null {
  if (raw === "8w" || raw === "month" || raw === "3m" || raw === "year") return raw;
  return null;
}
